import { DINER_WEB_INSTACART_GROCERY_PATH } from 'src/constants/urls';
import { Brands } from 'src/utilities/shared-types';

export function getGroceriesOrderNowUrl(brand?: string): string {
  const utmSource = brand || Brands.GRUBHUB;

  return (
    `${DINER_WEB_INSTACART_GROCERY_PATH}&` +
    `utm_source=${utmSource.toLowerCase()}_corpadmin&` +
    'utm_medium=content_owned&' +
    'utm_campaign=corpadmin_orders_grocery&' +
    'utm_content=corpadmin_grocery_order_now'
  );
}
